import encrypt from './encrypt'
import { request } from './requestModel'
import { parse } from './parse'
import { format } from './format'
import validations from './validations'
import {
    getJWTDetails,
    isConversionRequired,
    isDeliveryOrder,
    cleanParamsURL,
    getFullYear,
    getCurrentMonthName,
} from './appUtils'
import constants from './constants'
import { productUtility } from './productUtils'
import { alcoholUtility } from './alcoholutils'
import { startBridge, startStripe } from './mobileBridge'
import { revokeTokenUtility } from './revokeTokenUtil'

startBridge()

startStripe()

export const util = {
    ...constants,
    ...encrypt,
    ...request,
    ...parse,
    ...format,
    ...validations,
    ...productUtility,
    ...alcoholUtility,
    getJWTDetails,
    isConversionRequired,
    isDeliveryOrder,
    cleanParamsURL,
    getFullYear,
    getCurrentMonthName,
    revokeTokenUtility,
}
